import './PeriscopeV3PaginatedList.scss';
import { KeyPagination } from '@ui/KeyPagination';
import { PeriscopeList } from '.';
import { SonarRecord } from '@ui/records';
import { UpdateQueryParams } from '@hooks';
import { KeyPaginationQueryParams, PaginatedResource, PeriscopeBaseRecord } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useRef } from 'react';

export interface PeriscopeV3PaginatedListProps<T> {
	loading: boolean;
	onChange: UpdateQueryParams<KeyPaginationQueryParams>;
	queryParams: KeyPaginationQueryParams;
	renderListItem?: (item: T, index?: number) => JSX.Element;
	resource: PaginatedResource<T> | undefined;
}

export function PeriscopeV3PaginatedList<T>({
	loading,
	onChange,
	queryParams,
	renderListItem,
	resource
}: PeriscopeV3PaginatedListProps<T>): JSX.Element {
	const scrollableListRef = useRef<HTMLDivElement>(null);

	const renderList = useCallback(
		(items: T[]) =>
			items.map((item, childIndex) => {
				if (renderListItem) {
					return renderListItem(item, childIndex);
				}

				const castItem = item as unknown as PeriscopeBaseRecord;

				return (
					<SonarRecord
						key={ castItem.sonarObjectId }
						name={ castItem.displayName }
						sonarObjectId={ castItem.sonarObjectId } />
				);
			}),
		[ renderListItem ]
	);

	const results = resource?.results ?? [];

	return (
		<>
			<PeriscopeList
				list={ renderList }
				loading={ loading }
				ref={ scrollableListRef }
				results={ results } />
			<KeyPagination
				defaultPageSize={ queryParams.count ?? 20 }
				listRef={ scrollableListRef }
				onChange={ onChange }
				resource={ resource } />
		</>
	);
}
